/**
 * Copyright (c) Mayoral Moda Infantil, S.A.U. and affiliates.
 */

import { langIdVar, usernameVar } from '@graphql/cache';
import { useNavigationQuery } from '@graphql/queries/__generated__/navigation';
import { readFromCookies } from '@utils/cookies';
import React, { FC, PropsWithChildren, useMemo } from 'react';

import { StorageTokens } from '@/lib/constants';
import { Navigation } from '@/types/app-config';

export type SidebarContextValue = {
  loading: boolean;
  navigation: Navigation;
};

export const SidebarContext = React.createContext<SidebarContextValue>({
  loading: true,
  navigation: [],
});

type SideBarWrapperProps = PropsWithChildren<object>;

export const SidebarWrapper: FC<SideBarWrapperProps> = ({ children }) => {
  const selectedGroup: number = readFromCookies(StorageTokens.SELECTED_GROUP);

  const { data, loading } = useNavigationQuery({
    variables: {
      data: {
        user: {
          name: usernameVar(),
          language: langIdVar(),
        },
        ...(selectedGroup && {
          filters: {
            group: selectedGroup,
          },
        }),
      },
    },
  });

  const state: SidebarContextValue = useMemo(
    () => ({
      loading,
      navigation: data?.navigation || [],
    }),
    [loading, data],
  );

  return <SidebarContext.Provider value={state}>{children}</SidebarContext.Provider>;
};

export default SidebarContext;
